export default __webpack_public_path__ + "static/media/avatar-mp-1-1.1a129025.png";